import { render, staticRenderFns } from "./DataReport.vue?vue&type=template&id=16a56ca2&scoped=true&"
import script from "./DataReport.vue?vue&type=script&lang=js&"
export * from "./DataReport.vue?vue&type=script&lang=js&"
import style0 from "./DataReport.vue?vue&type=style&index=0&id=16a56ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a56ca2",
  null
  
)

export default component.exports